import { render, staticRenderFns } from "./TeamInfoPhase2.9.vue?vue&type=template&id=1caf58db"
import script from "./TeamInfoPhase2.9.vue?vue&type=script&lang=js"
export * from "./TeamInfoPhase2.9.vue?vue&type=script&lang=js"
import style0 from "./TeamInfoPhase2.9.vue?vue&type=style&index=0&id=1caf58db&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports